import React, { useEffect } from 'react';
import { Content, Footer, Header, PageContainer } from './styles';

type PublicPolicyPageProps = {
  scriptSrc: string;
  title: string;
};

const PublicPolicyPage: React.FC<PublicPolicyPageProps> = ({ scriptSrc, title }) => {
  useEffect(() => {
    const root = document.getElementById('__enzuzo-root');
    if (!root) return undefined;

    const script = document.createElement('script');
    script.id = '__enzuzo-root-script';
    script.src = scriptSrc;
    script.async = true;
    root.appendChild(script);

    return () => {
      if (root.contains(script)) {
        root.removeChild(script);
      }
    };
  }, [scriptSrc]);

  return (
    <PageContainer>
      <Header>{title}</Header>
      <Content>
        <div id="__enzuzo-root" />
      </Content>
      <Footer>Pride Global</Footer>
    </PageContainer>
  );
};

export default PublicPolicyPage;
